import { useSyncExternalStore } from 'react';

import { ResolvedTheme } from 'constants/theme';
import { currentDocumentTheme } from 'helper/theme';

function subscribe(onChange: () => void): () => void {
  const observer = new MutationObserver(onChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-bs-theme'] });
  return () => observer.disconnect();
}

/**
 * Tema que a página está usando AGORA (`data-bs-theme` do `<html>`): já considera a
 * preferência, o sistema e se a rota tem modo escuro. Não depende de Router nem de Redux,
 * então serve para gráfico, logo e qualquer coisa desenhada fora do CSS.
 */
export default function useDocumentTheme(): ResolvedTheme {
  return useSyncExternalStore(subscribe, currentDocumentTheme, () => 'light');
}
